import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent } from '@mui/material';

const About = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* About Header */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold' }}>
          About Kavya Institute
        </Typography>
        <Typography variant="h6" sx={{ color: '#666', mb: 4 }}>
          Empowering Students with Quality Education and Professional Excellence
        </Typography>
      </Box>

      {/* Main Content */}
      <Grid container spacing={4} sx={{ mb: 6 }}>
        <Grid item xs={12} md={8}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
            Our Story
          </Typography>
          <Typography paragraph>
            Kavya Institute was founded with a vision to provide world-class education and professional
            development training to students across India. Over the years, we have evolved into a trusted
            educational institution known for our commitment to excellence, innovation, and student success.
          </Typography>
          <Typography paragraph>
            Our journey has been marked by continuous growth, expansion of course offerings, and a strong
            commitment to incorporating the latest industry trends into our curriculum. We pride ourselves
            on having trained over 10,000+ successful professionals who are now making significant
            contributions in their respective fields.
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ backgroundColor: '#e3f2fd' }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Key Statistics
              </Typography>
              <Typography component="div">
                <strong>10,000+</strong> Students Trained<br />
                <strong>50+</strong> Courses Offered<br />
                <strong>100+</strong> Industry Experts<br />
                <strong>95%</strong> Placement Rate<br />
                <strong>10+</strong> Years in Education<br />
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Mission */}
      <Box sx={{ mb: 6, p: 4, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
          Our Mission
        </Typography>
        <Typography variant="body1" paragraph>
          To provide accessible, affordable, and high-quality education that equips students with
          practical skills, theoretical knowledge, and professional competencies required to excel
          in their chosen careers. We are committed to fostering a learning environment that encourages
          innovation, critical thinking, and lifelong learning.
        </Typography>
      </Box>

      {/* Vision */}
      <Box sx={{ mb: 6, p: 4, backgroundColor: '#e8f5e9', borderRadius: 2 }}>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
          Our Vision
        </Typography>
        <Typography variant="body1" paragraph>
          To be recognized as India's leading educational institution that transforms lives through
          education, creates skilled professionals, and contributes to national development. We envision
          a future where every student has access to quality education and the opportunity to achieve
          their full potential.
        </Typography>
      </Box>

      {/* Director's Message */}
      <Box sx={{ mb: 6, p: 4, backgroundColor: '#fff3e0', borderRadius: 2 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
          Director's Message
        </Typography>
        <Typography variant="body1" paragraph>
          "At Kavya Institute, we believe that education is the most powerful tool for personal and
          professional transformation. Over the past decade, we have witnessed countless success stories
          of our students who have gone on to lead successful careers and make meaningful contributions
          to society.
        </Typography>
        <Typography variant="body1" paragraph>
          Our commitment has always been to provide not just academic knowledge, but also to develop
          essential skills, ethics, and values that define true professionals. We leverage cutting-edge
          technology, industry expertise, and innovative teaching methodologies to ensure our students
          are always ahead in their careers.
        </Typography>
        <Typography variant="body1" paragraph>
          As we continue to grow, our mission remains unchanged: to empower every student with the
          knowledge, skills, and confidence they need to succeed. We invite you to be part of our
          learning community and embark on a journey of transformation."
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mt: 3 }}>
          - Dr. Rakesh Giri<br />
          Founder & Director<br />
          Kavya Institute
        </Typography>
      </Box>

      {/* Core Values */}
      <Box>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
          Our Core Values
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: 'Excellence',
              description: 'We pursue excellence in everything we do, from curriculum design to student mentoring.',
            },
            {
              title: 'Integrity',
              description: 'We operate with complete transparency and maintain the highest ethical standards.',
            },
            {
              title: 'Innovation',
              description: 'We continuously innovate and adapt to meet the evolving needs of the industry.',
            },
            {
              title: 'Student-Centric',
              description: 'Our students are at the heart of everything we do, and their success is our priority.',
            },
            {
              title: 'Inclusivity',
              description: 'We believe in inclusive education accessible to all, regardless of background.',
            },
            {
              title: 'Sustainability',
              description: 'We are committed to sustainable practices and responsible social contribution.',
            },
          ].map((value, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
                    {value.title}
                  </Typography>
                  <Typography variant="body2">
                    {value.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default About;
